"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommentDisplayText = getCommentDisplayText;
exports.getCommentDisplayHTML = getCommentDisplayHTML;
exports.extractMentionedUserId = extractMentionedUserId;
const COMMENT_REGEX = /@\[(.*?)]\((.*?)\)/g;
function getCommentDisplayText(rawComment) {
    // This regex looks for the @[display](id) pattern
    // Group 1 ($1) is the display name
    return rawComment.replace(COMMENT_REGEX, "@$1");
}
function getCommentDisplayHTML(rawComment) {
    if (!rawComment)
        return "";
    // 1. First, escape the entire string.
    // This turns "<" into "&lt;", which the browser renders visually as "<"
    // but won't confuse with an HTML tag.
    let safeHtml = rawComment
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    // 2. Now, inject your specific yellow-bold style.
    // We use the regex on the ALREADY ESCAPED string.
    // Note: Since we escaped first, the [display] part is already safe.
    safeHtml = safeHtml.replace(COMMENT_REGEX, (match, display, id) => {
        // Yellow-600 style for visibility
        const style = "color: #eab308; font-weight: bold; background-color: rgba(234, 179, 8, 0.1); padding: 0 2px; border-radius: 2px;";
        return `<strong style="${style}">@${display}</strong>`;
    });
    // 3. Convert new lines to <br/> so the formatting is preserved
    return safeHtml.replace(/\n/g, "<br/>");
}
function extractMentionedUserId(rawComment) {
    const mentionRegex = COMMENT_REGEX;
    const matches = [...rawComment.matchAll(mentionRegex)];
    // Group 1 is the (id) which we set as the userKey
    return matches.map((match) => match[2]);
}
